import React from "react";
import {useEffect,useState} from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheckSquare,
    faEye,
    faThumbsUp,
    faXmarkSquare,
  } from "@fortawesome/free-solid-svg-icons";
  import { Button, Modal } from "react-bootstrap";
function Inactive()
{
    const [product, setProduct] = useState([])
    const [search, setSearch] = useState([""])
    const [show, setShow] = useState(false);
    const [view, setView] = useState();
    const getProductData = async () => {
        try {
            const data = await axios.get
                (
                    `${process.env.REACT_APP_NODE_URL}/admin/publisher/inactive`
                );

            console.log(data.data);
            setProduct(data.data);
        }
        catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getProductData()
    }, [])

    const getViewPub=async(id)=>{
        setShow(true);
        try {
           
            const data = await axios.get(
              `${process.env.REACT_APP_NODE_URL}/admin/publisher/inactive/view/`+id
            );
         console.log("check",data.data)
            setView(data.data.data);
          } 
          catch (e) {
            console.log(e);
          }
        };
    
 const getActivateSub=()=>
 {
    alert();
 }
     const getActivate=(id)=>
    {

        axios
        .put(`${process.env.REACT_APP_NODE_URL}/admin/publisher/activate/domain/`+id,
        {
          mpi_id: id,
        })
        .then(function (response) {
          if(response.data.status===200)
          {
            alert("Activated");
            getProductData();
    
          }
         
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    return(
        <>
        <h2>Publisher Inactive List </h2>
        <div className="text-end">
        <input
                type="text"
                placeholder="search here"
                onChange={e => {
                    setSearch(e.target.value)
                }}
       />
       </div>
        <div className="overflow-y-scroll px-5 py-3">
    <table className="table table-bordered border-primary table-hover " >
        <thead className="table-dark ">
            <tr>
                <th scope="col">S.NO</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Website</th>
                <th scope="col">Actions</th>
               
            </tr>
        </thead>
        <tbody>
        
{
    console.log("product",product)
}
            {
                product.data !== undefined ?
                    product.data.filter(item => {
                        if (search === "") {
                            return item
                        }
                        else if (item.email.includes(search)) {
                            return item
                        }
                    })
                        .map((item, index) => {
                            return (
                                <tr>
                                    <th scope="row">{index}</th>
                                    <td>{item.firstname+item.lastname}</td>
                                    <td>{item.email}</td>
                                    <td>{item.mobile}</td>
                                    <td><a href={item.portal_url}>{item.portal_url}</a></td>
                                   <td>
                                   <FontAwesomeIcon
                            icon={faEye}
                            title="view"
                            style={{ color: "#044389" }}
                            onClick={() => getViewPub(item.mpi_id)}
                          />
                          {" "}
                          <FontAwesomeIcon
                            icon={faThumbsUp}    
                            title="Activate Subscription"
                            style={{ color: "#008000" }}
                            onClick={()=>getActivateSub(item.mpi_id)}
                        
                          />
                          {" "}
                          <FontAwesomeIcon
                            icon={faCheckSquare}
                            title="Activate"
                            style={{ color: "#008000" }}
                            onClick={()=> getActivate(item.mpi_id)}
                      
                          />
                          {" "}
                                   </td>

                                </tr> 
                            );
                        }) : null}

        </tbody>
    </table>
</div>
<Modal show={show} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View inActive Publisher</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {view !== undefined ?(
        <div className="overflow-y-scroll px-5 py-3">
            <table className="table table-bordered border-primary table-hover ">
              <thead className="table-dark ">
                <tr>
                  <th scope="col">S.NO</th>
                  <th scope="col">Name</th>
                  <th scope="col">Portal Name</th>
                  <th scope="col">Portal URL</th>
                  <th scope="col">Posted Date</th>
                  <th scope="col">Title</th>
                </tr>
              </thead>
              <tbody>
                {view !== undefined ? (
                  view.map((item, index) => (
                    <>
                      <tr>
                        <th scope="row">{index}</th>
                        <td>{item.marketer_firstname + item.marketer_lastname}</td>
                        <td>{item.portal_name}</td>
                        <td>{item.portal_url}</td>
                        <td>{item.posted_date}</td>
                        <td>{item.title}</td>
                      </tr>
                    </>
                  ))
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </div>
          ):(
           <><p> No Records Found </p></>
          ) }
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow(false);
            }}
          >
            Close
          </Button>
          
        </Modal.Footer>
      </Modal>
        </>
    );
};
export default Inactive;